var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpanishFlag = function SvgSpanishFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.095c0-1.982-.568-3.763-1.553-5.404H1.553C.568 6.332 0 8.113 0 10.095c0 1.944.556 3.813 1.503 5.328h16.994C19.444 13.908 20 12.04 20 10.095Z",
    fill: "#FFCD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 .032c-3.548 0-6.667 2.007-8.447 4.659h16.894C16.667 2.039 13.548.03 10 .03ZM18.497 15.423H1.503c1.553 2.526 4.166 4.167 7.21 4.546h2.562c3.056-.379 5.67-2.02 7.222-4.546Z",
    fill: "#FF1300"
  })));
};
export default SvgSpanishFlag;